export const FINANCE_STATISTICS_BACK_STATE = 'finance-statistics';

export const getFinanceStatisticsBackPath = (
  defaultBackPath: string,
  locationState: unknown
) =>
  locationState === FINANCE_STATISTICS_BACK_STATE ? '' : defaultBackPath;
